import React from 'react';
import styles from './logo.module.css';
import logo from '../../../logo.jpg';

const LogoBanner = () => {
    return (
        <section className={styles.bannerContainer}>
            <div 
                className={styles.backgroundImage} 
                style={{ backgroundImage: `url(${logo})` }}
            >
                {/* O overlay aqui ajuda a suavizar a transição se a imagem não for 100% preta */}
                <div className={styles.overlay}></div>
            </div>
        </section>
    );
};

export default LogoBanner;